module.exports = __webpack_public_path__ + "static/media/secretBanner_sm3.4a8a87f0.png";